import { Component } from '@angular/core';
import { DialogBaseViewComponent, SimpleDialogData } from '@sb/library/base';

@Component({
    selector: 'lib-dialog-info',
    templateUrl: './dialog-info.component.html',
    styleUrls: ['./dialog-info.component.scss']
})
export class DialogInfoComponent extends DialogBaseViewComponent<SimpleDialogData> {
    override readonly dismissible: boolean = true;

    override PrimaryAction() {
        super.PrimaryAction();
        this.DismissAction();
    }

    get primaryButtonText(): string {
        return this.data.PrimaryButtonText ?? $localize`:@@CommonClose:Close`;
    }
}
